import {action, makeObservable, observable} from 'mobx';

export default class ModalStore {
    initialized = false;
    posthogTrackingEnabled = false;
    userId = null;

    constructor(initData) {
        this.initialize(initData);

        makeObservable(this, {
            stack: observable,
            addModal: action,
            clearAllModals: action,
            removeTop: action,
        });
    }

    initialize = (initData) => {
        if (initData) {
            this.currentOrgId = initData.currentOrganization.id;
            this.posthogTrackingEnabled = initData.featureFlags?.posthog_tracking_enabled?.enabled ?? false;
            this.userId = initData.user?.id ?? null;
            this.initialized = true;
        }
    };

    serialize = () => {
        return {
            currentOrganization: {
                id: this.currentOrgId,
            },
            featureFlags: {
                posthog_tracking_enabled: { enabled: this.posthogTrackingEnabled },
            },
            currentUser: {
                id: this.userId,
            },
        }
    }

    stack = [];

    removeTop = () => {
        this.stack.pop();
    };

    _trackModalEvent = (modalObj) => {
        if (!this.posthogTrackingEnabled || typeof window === 'undefined') {
            return;
        }

        const properties = {
            modal_type: modalObj.type,
            organization_id: this.currentOrgId,
            user_id: this.userId,
            ...modalObj.posthog_params,
        };

        import('posthog-js').then(({ default: posthog }) => {
            posthog.capture('modal_opened', properties);
        });
    };

    addModal = (modalObj) => {
        this.stack.push(modalObj);
        this._trackModalEvent(modalObj);
    };

    clearAllModals = () => {
        this.stack.length = 0;
    };
}

